import React, { PureComponent } from 'react';

import Button from 'Component/Button';
import Icons from 'Component/Icons';
import NewsletterSubscription from 'Component/NewsletterSubscription';
import BrowserDatabase from 'Util/BrowserDatabase';

import { ADVOX_POPUP_PREFIX, POPUP_NEWSLETTER_TYPE, POPUP_PROMOTION_TYPE, POPUP_SHOW_AFTER } from './AdvoxPopup.config';

import './AdvoxPopup.style';

/** @namespace Pwa/Component/AdvoxPopup/Component */
export class AdvoxPopupComponent extends PureComponent {
    state = {
        isPopUpBasedOnTimeToShow: false,
        isPopUpBasedOnTabToShow: false,
    };

    componentDidUpdate() {
        const { popups } = this.props;

        popups?.forEach(({ time_to_show: timeToShow, when_to_show: whenToShow }) => {
            if (whenToShow.includes('time')) {
                setTimeout(
                    () => {
                        this.setState({ isPopUpBasedOnTimeToShow: true });
                    },
                    timeToShow ? timeToShow * 1000 : POPUP_SHOW_AFTER
                );
            }

            if (whenToShow.includes('tab_closure')) {
                document.documentElement.addEventListener('mouseleave', (e) => this.handleMouseMove(e));
            }
        });
    }

    handleMouseMove(event) {
        const { clientY, clientX } = event || {};
        const { innerWidth, innerHeight } = window || {};
        const isMouseOutsideDocument = clientY <= 0 || clientX <= 0 || clientX >= innerWidth || clientY >= innerHeight;

        if (isMouseOutsideDocument) {
            this.setState({ isPopUpBasedOnTabToShow: true });
        }
    }

    renderContent(popup) {
        const { id, description, button_cta, button_link, button_color, type, banner } = popup;
        const popupFullId = `${ADVOX_POPUP_PREFIX}_${id}`;
        const { closePopupHandle } = this.props;

        return (
            <div id={popupFullId} block="AdvoxPopup" key={popupFullId} onClick={() => closePopupHandle(id)}>
                <div
                    block="AdvoxPopup"
                    elem="Content"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <div block="AdvoxPopup" elem="Wrapper">
                        <div block="AdvoxPopup" elem="Close" onClick={() => closePopupHandle(id)}>
                            <Icons name="close" />
                        </div>
                        <img block="AdvoxPopup" elem="Banner" src={banner} alt={`banner_${id}`} />
                        <div block="AdvoxPopup" elem="ContentWrapper">
                            <div
                                block="AdvoxPopup"
                                elem="Description"
                                dangerouslySetInnerHTML={{ __html: description }}
                            />
                            {type === POPUP_NEWSLETTER_TYPE ? (
                                <NewsletterSubscription
                                    key="NewsletterSubscription"
                                    inPopup
                                    onSuccess={() => closePopupHandle(id)}
                                />
                            ) : null}
                            {type === POPUP_PROMOTION_TYPE && +button_cta ? (
                                <div block="AdvoxPopup" elem="PromoButton">
                                    <Button
                                        asLink
                                        to={button_link}
                                        onClick={() => closePopupHandle(id)}
                                        style={{
                                            background: button_color,
                                            borderColor: button_color,
                                        }}
                                    >
                                        {__('Check')}
                                    </Button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderAdvoxPopup(popup) {
        const { isMobile, isTablet } = this.props;
        const {
            id,
            show_on_desktop: showDesktop,
            show_on_mobile: showMobile,
            when_to_show: whenToShow,
            end_date: endDate,
        } = popup;

        const { isPopUpBasedOnTimeToShow, isPopUpBasedOnTabToShow } = this.state;

        const popupFullId = `${ADVOX_POPUP_PREFIX}_${id}`;
        const popupStorage = BrowserDatabase.getItem(popupFullId);
        const displayTo = new Date(endDate).getTime() - new Date().getTime();
        if (popupStorage || displayTo < 0) return null;

        if ((isMobile && !showMobile) || (isTablet && !showDesktop)) return null;

        if (whenToShow.includes('time')) {
            if (isPopUpBasedOnTimeToShow) {
                return this.renderContent(popup);
            }
        }

        if (whenToShow.includes('tab_closure')) {
            if (isPopUpBasedOnTabToShow) {
                return this.renderContent(popup);
            }
        }

        return null;
    }

    renderAdvoxPopups() {
        const { popups } = this.props;
        if (!popups?.length) return null;
        return popups.map(this.renderAdvoxPopup.bind(this));
    }

    render() {
        return this.renderAdvoxPopups();
    }
}

export default AdvoxPopupComponent;
